// Custom Scripts
$(document).ready(function () {
    console.log('ZoneGp Loaded');

    // --- Dynamic Template Loading ---
    $('#header-placeholder').load('templates/header.html', function () {
        console.log('Header Loaded');
    });

    $('#footer-placeholder').load('templates/footer.html', function () {
        console.log('Footer Loaded');
    });

    // --- Slick Slider Initialization: Product Carousel ---
    $('.scroll-container').slick({
        dots: true,
        infinite: false,
        speed: 300,
        autoplay: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        // prevArrow: $('.scroll-container .carousel-prev'), // target your custom class
        // nextArrow: $('.scroll-container .carousel-next'), // target your custom class
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        ]
    });

    // --- Google Reviews Carousel ---
    $('.google-reviews-carousel').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    });

    // --- Google Reviews Carousel (Sidebar / Contact Page) ---
    $('.google-reviews-carousel-sidebar').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false
    });

    // --- Testimonial Hero Slider ---
    $('.testimonial-hero-slider').slick({
        dots: true,
        infinite: true,
        speed: 1000,
        fade: false,
        cssEase: 'ease-out',
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false
    });

    // --- Product Tabs Filtering ---
    $('.nav-pills-custom .nav-link').on('click', function (e) {
        // Remove active class from all buttons
        $('.nav-pills-custom .nav-link').removeClass('active');
        // Add active class to clicked button
        $(this).addClass('active');

        const categoryTarget = $(this).attr('data-bs-target');
        // Map the target ID to our category names
        let category = 'all';
        if (categoryTarget === '#pills-airpods') category = 'airpods';
        else if (categoryTarget === '#pills-charging') category = 'charging';
        else if (categoryTarget === '#pills-accessories') category = 'accessories';

        // Filter Slick Slider
        if ($carousel.length) {
            $carousel.slick('slickUnfilter');

            if (category !== 'all') {
                $carousel.slick('slickFilter', `[data - category= "${category}"]`);
            }
        }
    });

    // product page slider sink
    // $('.main-slider').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     fade: true,
    //     asNavFor: '.thumbnail-slider',
    //     infinite: true,
    //     autoplay: false,
    //     dots: false,
    //     adaptiveHeight: true,
    // });

    // // Initialize thumbnail slider
    // $('.thumbnail-slider').slick({
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     asNavFor: '.main-slider',
    //     dots: false,
    //     arrows: false,
    //     centerMode: false,
    //     focusOnSelect: true,
    //     infinite: true,
    //     responsive: [
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 3,
    //                 arrows: false
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 2,
    //                 arrows: false
    //             }
    //         }
    //     ]
    // });

    // 1. Initialize the main slider (Notice: 'asNavFor' is removed from here)
    $('.main-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        infinite: true,
        autoplay: false,
        dots: false,
        adaptiveHeight: true,
    });

    // 2. Initialize thumbnail slider (Notice: 'asNavFor' is also removed from here)
    $('.thumbnail-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    arrows: false
                }
            }
        ]
    });

    // 3. The magic sauce: Link them safely after both are initialized
    $('.main-slider').slick('slickSetOption', 'asNavFor', '.thumbnail-slider', true);
    $('.thumbnail-slider').slick('slickSetOption', 'asNavFor', '.main-slider', true);

    // prouduct lightbox zoom
    $('.main-image-slide img').click(function () {
        var imgSrc = $(this).attr('src');
        var imgAlt = $(this).attr('alt');

        // Create lightbox overlay
        var lightbox = $('<div class="lightbox-overlay"></div>');
        var lightboxContent = $('<div class="lightbox-content"><img src="' + imgSrc + '" alt="' + imgAlt + '"></div>');
        var closeBtn = $('<span class="lightbox-close">&times;</span>');

        lightboxContent.append(closeBtn);
        lightbox.append(lightboxContent);
        $('body').append(lightbox);

        // Close lightbox
        closeBtn.click(function () {
            lightbox.remove();
        });

        lightbox.click(function (e) {
            if (e.target === this) {
                lightbox.remove();
            }
        });
    });

    // Optional: Add click handler for thumbnail items if needed
    $('.thumbnail-item').on('click', function () {
        var slideIndex = $(this).closest('.thumbnail-slide').data('slick-index');
        $('.main-slider').slick('slickGoTo', slideIndex);
    });

    // --- Product Quantity Buttons ---
    $('.qty-increase').on('click', function () {
        var input = $(this).siblings('input[name="quantity"]');
        var currentVal = parseInt(input.val()) || 1;
        input.val(currentVal + 1);
    });

    $('.qty-decrease').on('click', function () {
        var input = $(this).siblings('input[name="quantity"]');
        var currentVal = parseInt(input.val()) || 1;
        if (currentVal > 1) {
            input.val(currentVal - 1);
        }
    });

    // --- Add to Cart with Spinner and Redirect ---
    $('#AddToCartForm').on('submit', function (e) {
        e.preventDefault();
        
        var form = $(this);
        var submitBtn = $('#AddToCart');
        var originalText = submitBtn.html();
        
        // Disable button and show spinner
        // submitBtn.prop('disabled', true);
        submitBtn.html('<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Adding...');
        
        // Get form data
        var formData = new FormData(form[0]);
        
        // Submit to cart using Fetch API
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams(formData).toString(),
            credentials: 'same-origin'
        })
        .then(response => {
            // Check if response is ok and parse JSON
            return response.json().then(data => {
                if (!response.ok) {
                    // Shopify returns error details in JSON
                    throw new Error(data.description || data.message || 'Failed to add to cart');
                }
                return data;
            });
        })
        .then(data => {
            console.log('Product added to cart:', data);
            
            // Show success message briefly
            submitBtn.html('<i class="fas fa-check me-2"></i>Added!');
            
            // Redirect to checkout after a brief delay
            setTimeout(function () {
                window.location.href = '/checkout';
            }, 500);
        })
        .catch(error => {
            // Silently handle error - no console log or alert
            
            // Restore button to original state
            setTimeout(function () {
                submitBtn.html(originalText);
            }, 500);
        });
    });

    // --- Cart Counter Logic Removed ---
});